import { render, staticRenderFns } from "./ModalErrorProvider.vue?vue&type=template&id=50ec7f46&scoped=true&"
import script from "./ModalErrorProvider.vue?vue&type=script&lang=js&"
export * from "./ModalErrorProvider.vue?vue&type=script&lang=js&"
import style0 from "./ModalErrorProvider.vue?vue&type=style&index=0&id=50ec7f46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ec7f46",
  null
  
)

export default component.exports